<template >
  <base-dialog-form ref="gestCausaleDialog" :title="computedTitle" :text="causale.descr" color="secondary"
    icon="mdi-file-cog-outline">
    <template v-slot:actions v-if="method !== 'VIEW'">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" v-if="operaz !== 'VIEW'" @click="saveCausale" color="success">{{ $t("save") }}</v-btn>
          <v-btn class="mx-5" v-if="operaz === 'EDIT'" @click="deleteCausale" color="error">{{ $t("delete") }}</v-btn>
        </v-col>
      </v-row>
    </template>

    <v-container>
      <form>
        <v-row>
          <v-col cols="3">
            <v-checkbox :disabled="operaz === 'VIEW'" :false-value="0" :true-value="1" v-model="causale.ifProto"
              :label="$t('if_protocol')"></v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox :disabled="operaz === 'VIEW'" :false-value="0" :true-value="1" v-model="causale.ifRicevuta"
              :label="$t('if_receipt')"></v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox :disabled="operaz === 'VIEW'" :false-value="0" :true-value="1" v-model="causale.ifCdx"
              :label="$t('if_cdx')"></v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox :disabled="operaz === 'VIEW'" :false-value="0" :true-value="1" v-model="causale.ifGiroconto"
              :label="$t('if_giroconto')"></v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="12">
            <v-autocomplete v-model="causale.defaultFor" :items="listOrderType" item-text="dex" item-value="code"
              :disabled="operaz === 'VIEW'" :label="$t('used_by_default_for')" multiple chips color="primary"
              :hint="$t('used_by_default_for')" persistent-hint></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-select v-model="causale.cdxEntrata" item-value="cdxId" item-text="descr" :items="listCdp"
              :disabled="operaz === 'VIEW'" :menu-props="{ maxHeight: '400' }" :label="$t('cdp')" required color="primary"
              persistent-hint></v-select>
          </v-col>
          <v-col cols="4">
            <v-select v-model="causale.cdxUscita" item-value="cdxId" item-text="descr" :items="listCdc"
              :disabled="operaz === 'VIEW'" :menu-props="{ maxHeight: '400' }" :label="$t('cdc')" required color="primary"
              persistent-hint></v-select>
          </v-col>
          <v-col cols="4">
            <v-select v-model="causale.controCausale" :items="listCausali" item-value="cauId" item-text="descr"
              :disabled="operaz === 'VIEW'" :menu-props="{ maxHeight: '400' }" :label="$t('causale_4_refound')" required
              color="primary" persistent-hint></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="1">
            <v-text-field v-model="causale.serie" :disabled="operaz === 'VIEW'" :label="$t('reg_serie')"
              hide-details="auto"></v-text-field>
          </v-col>
          <v-col cols="11">
            <v-text-field v-model="causale.descr" :disabled="operaz === 'VIEW'" :label="$t('text')" :rules="required"
              hide-details="auto"></v-text-field>
          </v-col>
        </v-row>
      </form>
    </v-container>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";

export default {
  name: "edit-causale",
  data() {
    return {
      cauId: null,
      method: null,
      operaz: null,
      type: null,
      typeDex: null,
      causale: {},
      listCdc: [],
      listCdp: [],
      listCausali: [],
      listOrderType: [],
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  methods: {
    open(method, cauId) {
      this.method = method;
      this.cauId = cauId;
      this.loadData();
      this.$refs.gestCausaleDialog.open();
    },
    loadData() {
      let _ = this;
      let url = null;
      _.causale = {};
      _.isFetching = true;

      _.operaz = _.method;

      if (_.cauId) {
        _.chiamataAxios("GET", "/auth/contab/getCausale/" + _.cauId).then(
          (response) => {
            _.causale = response.data;
            _.listOrderType = _.causale.listOrderType;
          }
        );
      } else {
        _.chiamataAxios("GET", "/auth/portal/listOrderType").then(
          (response) => {
            _.listOrderType = response.data;
          }
        );
      }
    },

    deleteCausale(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        customClass: "v-application",
        showCancelButton: true,
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios("DELETE", "/auth/contab/deleteCausale/" + _.cauId, {
            dialogLoader: true,
          }).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.$emit("isUpdated", "true");
              _.$refs.gestCausaleDialog.close();
            }
          });
        }
      });
    },
    saveCausale: function () {
      let _ = this;
      let url = "/auth/contab/updateCausale/" + _.cauId;
      let operaz = "POST";
      if (_.operaz == "ADD") {
        url = "/auth/contab/createCausale";
        operaz = "PUT";
      }

      _.chiamataAxios(operaz, url, {
        dialogLoader: true,
        body: _.causale,
      }).then((response) => {
        if (response.msg.esito) {
          let html = "<strong>" + response.msg.msgTxt + "</strong>";
          Swal.fire({
            type: "success",
            html: html,
          });
          _.$emit("isUpdated", "true");
          _.$refs.gestCausaleDialog.close();
        }
      });
    },
  },
  mounted() {
    let _ = this;

    _.listCausali = [];
    this.chiamataAxios("GET", "/auth/contab/listCausali").then((response) => {
      _.listCausali = response.data;
      _.listCausali.unshift({ cauId: null, descr: "" });
    });

    _.listCdc = [];
    _.listCdp = [];
    _.chiamataAxios("GET", "/auth/contab/listCdx").then((response) => {
      _.listCdc = response.data.cdc;
      _.listCdp = response.data.cdp;
      _.listCdc.unshift({ cdxId: null, descr: "" });
      _.listCdp.unshift({ cdxId: null, descr: "" });
    });
  },
  computed: {
    computedTitle: function () {
      if (this.method === "EDIT") return this.$t("edit_causale");
      else if (this.method === "VIEW") return this.$t("view_causale");
      else if (this.method === "ADD") return this.$t("create_causale");
      else return "";
    },
  },
};
</script>